<template>
  <HubContainer id="visualConfigurationsHub">

    <template v-if="atLeastSuperAdmin">
      <HubSection large icon="icon/hub/visual-configuration.svg"
                  :title="$t('items.online_ordering')"
                  :description="$t('items.online_ordering_description')"
                  :buttonAction="goToOnlineOrderingStyle">
      </HubSection>

      <HubSection large icon="icon/hub/custom-translation.svg"
                  :title="$t('translations.title')"
                  :description="$t('translations.description_short')"
                  :buttonAction="goToTranslation">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "visualConfigurationsHub",

    components: {HubSection, HubContainer},

    mounted() {
      this.$store.state.pageTitleTranslationKey = "style.title";
      this.$store.state.pageIcon = "icon/art.svg";
    },

    computed: {
      atLeastSuperAdmin() {
        return this.$store.getters.loggedUserHasSuperAdmin;
      },
    },

    methods: {
      goToOnlineOrderingStyle() {
        this.$router.push(this.$router.buildContext("/style/online-ordering"));
      },
      goToTranslation() {
        this.$router.push(this.$router.buildContext("/translations"));
      }
    }
  }
</script>